import React, { useContext } from 'react';
import { ThemeContext } from "../../../../lib/theming/ThemeContext";
import { isTheme2022 } from "../../../../lib/theming/ThemeHelpers";
import { DeleteIcon, ErrorIcon, OkIcon } from "../../../icons/16px";
import { FileUploaderFileStatus } from "../../fileUtils";
import { LoadingIcon } from "../../../icons2022/LoadingIcon";
import { DeleteIcon as DeleteIcon2022 } from "../DeleteIcon";
import { ErrorIcon as ErrorIcon2022 } from "../ErrorIcon";
import { OkIcon as OkIcon2022 } from "../OkIcon";
import { jsStyles } from "../FileUploaderFile.styles";
export var FileUploaderFileStatusIcon = function FileUploaderFileStatusIcon(_ref) {
  var hovered = _ref.hovered,
      focusedByTab = _ref.focusedByTab,
      isInvalid = _ref.isInvalid,
      status = _ref.status,
      size = _ref.size;
  var theme = useContext(ThemeContext);
  var IconDelete = /*#__PURE__*/React.createElement(DeleteIcon, {
    className: jsStyles.deleteIcon(theme)
  });
  var IconError = /*#__PURE__*/React.createElement(ErrorIcon, null);
  var IconOk = /*#__PURE__*/React.createElement(OkIcon, {
    color: theme.fileUploaderIconColor
  });

  if (isTheme2022(theme)) {
    IconDelete = /*#__PURE__*/React.createElement(DeleteIcon2022, {
      size: size,
      className: jsStyles.deleteIcon(theme)
    });
    IconError = /*#__PURE__*/React.createElement(ErrorIcon2022, {
      size: size
    });
    IconOk = /*#__PURE__*/React.createElement(OkIcon2022, {
      size: size,
      color: theme.fileUploaderIconColor
    });
  }

  if (hovered || focusedByTab) {
    return IconDelete;
  }

  if (isInvalid) {
    return IconError;
  }

  switch (status) {
    case FileUploaderFileStatus.Loading:
      return /*#__PURE__*/React.createElement(LoadingIcon, {
        size: size
      });

    case FileUploaderFileStatus.Uploaded:
      return IconOk;

    default:
      return IconDelete;
  }
};